import { TAssetEditorProp } from '../../assetEditorProps'
import * as THREE from 'three'
import {
    AMAMeshType,
    isCamera,
    isCustomShapes,
    isLight,
    isSpecificObject,
    utilsEditor
} from '@amaspace-editor/editor-3d'

const meshActions = (key: string, value: TAssetEditorProp['value'], editor3D: ReturnType<typeof utilsEditor>) => {
    if (!editor3D.activeMesh) return
    const keyProp = key.split('_').slice(-1)[0]
    const keyValue = key.split('_')[0]
    if (keyProp === 'prop') {
        if (value instanceof THREE.Vector3 || value instanceof THREE.Euler) {
            //@ts-ignore
            editor3D.activeMesh[keyValue].copy(value)
        } else {
            //@ts-ignore
            editor3D.activeMesh[keyValue] = value
        }
        editor3D.updateObjectData(editor3D.activeMesh, { [keyValue]: value })
    }
    if (keyProp === 'camera') {
        const camera = editor3D.getCurrentConfigObj(editor3D.activeMesh)
        if (!isCamera(camera)) return
        editor3D.updateObjectData(editor3D.activeMesh, {
            [keyValue]: {
                ...camera?.target,
                object: value.object
            }
        })
    }
    if (keyProp === 'ar') {
        editor3D.updateObjectData(editor3D.activeMesh, {
            userData: {
                ...editor3D.activeMesh.userData,
                [keyValue]: value
            }
        })
    }
    if (keyProp === 'target') {
        const camera = editor3D.getCurrentConfigObj(editor3D.activeMesh)
        const target = editor3D.getMeshById(value.object)
        const newTargetPosition = target?.position.clone() || new THREE.Vector3(0, 0, 0)

        if (!isCamera(camera)) return

        editor3D.updateObjectData(editor3D.activeMesh, {
            target: {
                ...camera?.target,
                object: value.object,
                position: newTargetPosition
            }
        })
        if (
            editor3D?.controls?.target &&
            newTargetPosition &&
            editor3D.activeMesh.userData.id === editor3D.activeCamera.userData.id
        ) {
            editor3D.controls.target = newTargetPosition
            editor3D?.controls?.update()
        }
    }
    if (keyProp === 'scene') {
        //@ts-ignore
        editor3D.activeMesh[keyValue] = value
        editor3D.updateObjectData(editor3D.activeMesh, { [keyValue]: value })
    }
    if (keyProp === 'mat') {
        if ('isMesh' in editor3D.activeMesh) {
            const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)
            if (current) {
                if (!isSpecificObject(current, AMAMeshType.Mesh)) return
                editor3D.updateObjectData(editor3D.activeMesh, {
                    updatedMaterial: { ...current.updatedMaterial, [keyValue]: value }
                })
            }
        }
    }
    if (keyProp === 'geom') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)
        if (current) {
            if (!isCustomShapes(current)) return
            editor3D.updateObjectData(editor3D.activeMesh, {
                updatedGeometry: { ...current.updatedGeometry, [keyValue]: +value }
            })
        }
    }
    if (key === 'castShadow_light') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)

        if (!isLight(current)) return

        editor3D.updateObjectData(editor3D.activeMesh, {
            updatedLight: { ...current?.updatedLight, castShadow: value }
        })
    }
    if (keyProp === 'parent') {
        if (!editor3D.activeMesh) return
        editor3D.updateObjectData(editor3D.activeMesh, {
            userData: {
                ...editor3D.activeMesh.userData,
                parent: value.object
            }
        })
    }
    if (key === 'intensity') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)
        if (!isLight(current)) return

        editor3D.updateObjectData(editor3D.activeMesh, {
            updatedLight: { ...current?.updatedLight, intensity: value }
        })
    }

    if (key === 'angle') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)

        if (editor3D.activeMesh.children[0] instanceof THREE.SpotLight) {
            if (!isLight(current)) return
            editor3D.updateObjectData(editor3D.activeMesh, {
                updatedLight: { ...current?.updatedLight, angle: value }
            })
        }
    }
    // if (key === 'side') {
    //     const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)
    //     if (current) {
    //         editor3D.updateObjectData(editor3D.activeMesh, {
    //             updatedMaterial: {
    //                 ...current.updatedMaterial,
    //                 side: objectUtils<typeof MATERIAL_SIDES>({ obj: MATERIAL_SIDES, key: value }).value as THREE.Side
    //             }
    //         })
    //     }
    // }
    //
    // if (key === 'blending') {
    //     const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)
    //     if (current) {
    //         editor3D.updateObjectData(editor3D.activeMesh, {
    //             updatedMaterial: {
    //                 ...current.updatedMaterial,
    //                 blending: objectUtils({ obj: BLENDING_TYPES, key: value }).value as THREE.Blending
    //             }
    //         })
    //     }
    // }

    if (key === 'color_light') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)

        if (!isLight(current)) return

        editor3D.updateObjectData(editor3D.activeMesh, { updatedLight: { ...current?.updatedLight, color: value } })
    }
}

export { meshActions }
